"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Theme_1 = require("../model/Theme");

var ThemeConverter_1 = require("./ThemeConverter");
/**
 * Default implementation of ThemeConverter.
 *
 * @author JMt
 */


var ThemeConverterImpl =
/*#__PURE__*/
function (_ThemeConverter_1$The) {
  _inherits(ThemeConverterImpl, _ThemeConverter_1$The);

  function ThemeConverterImpl() {
    _classCallCheck(this, ThemeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThemeConverterImpl).apply(this, arguments));
  }

  _createClass(ThemeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Theme_1.Theme(Theme_1.Theme.schema.id.valueOf(conversions.documentToClassId(source)), Theme_1.Theme.schema.name.valueOfField(source), Theme_1.Theme.schema.description.valueOfField(source), Theme_1.Theme.schema.validFrom.valueOfField(source), Theme_1.Theme.schema.validTo.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        description: source.description,
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo)
      });
      return result;
    }
  }]);

  return ThemeConverterImpl;
}(ThemeConverter_1.ThemeConverter);

exports.ThemeConverterImpl = ThemeConverterImpl;